import axiosInstance from './axiosInstance';

export const GetAllStoreDetails = async () => {
  try {
    const { data } = await axiosInstance.get(`/store`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetStoreByID = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/Store/id/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const EditStoreApi = async (store_id, name, email, contact, manager_id, street_address, city, state, postal_code, tax) => {
  try {
    const { data } = await axiosInstance.put(`/store/${store_id}`, {
      name: name,
      email: email,
      contact: contact,
      location: {
        street_address: street_address,
        city: city,
        state: state,
        postal_code: postal_code,
      },
      manager_id: manager_id,
      tax: tax,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const GetAllStores = async () => {
  try {
    const { data } = await axiosInstance.get(`/store/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddStoreApi = async (name, email, contact, manager_id, street_address, city, state, postal_code, tax) => {
  try {
    const { data } = await axiosInstance.post(`/store`, {
      name: name,
      email: email,
      contact: contact,
      location: {
        street_address: street_address,
        city: city,
        state: state,
        postal_code: postal_code,
      },
      manager_id: manager_id,
      tax: tax,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddOpeningBalance = async (store_id, part_id, min_stock, max_stock, opening_balance, user_id) => {
  try {
    const { data } = await axiosInstance.post(`/inventory`, {
      store_id: store_id,
      part_id: part_id,
      unit_instock: opening_balance,
      min_stock: min_stock,
      max_stock: max_stock,
      opening_balance: opening_balance,
      user_id: user_id,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddOutStock = async (store_id, part_id, quantity, notes, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/inventory/StockOut`, {
      store_id: store_id,
      part_id: part_id,
      quantity: quantity,
      note: notes,
      new_store_id: store_id,
      user_id: user_id,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddInStock = async (store_id, part_id, quantity, notes, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/inventory/StockIn`, {
      store_id: store_id,
      part_id: part_id,
      quantity: quantity,
      note: notes,
      new_store_id: store_id,
      user_id: user_id,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddTransferStock = async (store_id, part_id, quantity, notes, new_store_id, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/inventory/Transfer`, {
      store_id: store_id,
      part_id: part_id,
      quantity: quantity,
      note: notes,
      new_store_id: new_store_id,
      user_id: user_id,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
